<hlm-dialog [state]="dialogState()" (closed)="onDialogClosed()">
  <hlm-dialog-content *brnDialogContent="let ctx" class="sm:max-w-lg">
    <hlm-dialog-header>
      <h3 hlmDialogTitle>Herunterladen</h3>
      <p hlmDialogDescription>Wähle aus, was du herunterladen möchtest. Alles wird als ZIP geliefert.</p>
    </hlm-dialog-header>

    <!-- Loading tags -->
    @if (phase() === 'loading-tags') {
      <div class="flex items-center gap-3 py-6 text-sm text-muted-foreground">
        <span class="w-4 h-4 rounded-full border-2 border-primary border-t-transparent animate-spin shrink-0"></span>
        Verfügbare Dateien werden ermittelt…
      </div>
    }

    <!-- Choosing -->
    @if (phase() === 'choosing') {
      <div class="space-y-4 py-2">

        <!-- CSV section -->
        <div class="space-y-2">
          <p class="text-xs font-bold text-muted-foreground uppercase tracking-wide">CSV-Export</p>
          <label class="flex items-center gap-3 rounded-lg border p-3 cursor-pointer transition-colors"
            [class]="includeCsv() ? 'border-primary bg-primary/5' : 'border-border hover:bg-muted/40'">
            <input
              type="checkbox"
              [checked]="includeCsv()"
              (change)="toggleCsv()"
              class="rounded border-input accent-primary"
            />
            <div class="flex items-center gap-2.5">
              <div class="w-8 h-8 rounded-md border bg-muted/50 flex items-center justify-center shrink-0">
                <ng-icon name="lucideFileText" class="w-4 h-4 text-muted-foreground" />
              </div>
              <div>
                <p class="text-sm font-normal">Kampagnen-CSV</p>
                <p class="text-xs text-muted-foreground">Alle Analyseergebnisse als Tabelle</p>
              </div>
            </div>
          </label>
        </div>

        <!-- Media section -->
        @if (availableTags().length > 0) {
          <div class="space-y-2">
            <p class="text-xs font-bold text-muted-foreground uppercase tracking-wide">Mediendateien</p>

            @if (tags2d().length > 0) {
              <div class="space-y-1.5">
                <div class="flex items-center gap-2 px-1">
                  <ng-icon name="lucideImage" class="w-3.5 h-3.5 text-muted-foreground" />
                  <span class="text-xs text-muted-foreground font-normal">2D</span>
                </div>
                @for (tag of tags2d(); track tag.tag) {
                  <label class="flex items-center gap-3 rounded-lg border p-3 cursor-pointer transition-colors"
                    [class]="selectedTags().has(tag.tag) ? 'border-primary bg-primary/5' : 'border-border hover:bg-muted/40'">
                    <input
                      type="checkbox"
                      [checked]="selectedTags().has(tag.tag)"
                      (change)="toggleTag(tag.tag)"
                      class="rounded border-input accent-primary"
                    />
                    <div class="flex items-center gap-2.5">
                      <div class="w-8 h-8 rounded-md border bg-muted/50 flex items-center justify-center shrink-0">
                        <ng-icon name="lucideImage" class="w-4 h-4 text-muted-foreground" />
                      </div>
                      <span class="text-sm font-normal">{{ tag.label }}</span>
                    </div>
                  </label>
                }
              </div>
            }

            @if (tags3d().length > 0) {
              <div class="space-y-1.5">
                <div class="flex items-center gap-2 px-1">
                  <ng-icon name="lucideBox" class="w-3.5 h-3.5 text-muted-foreground" />
                  <span class="text-xs text-muted-foreground font-normal">3D</span>
                </div>
                @for (tag of tags3d(); track tag.tag) {
                  <label class="flex items-center gap-3 rounded-lg border p-3 cursor-pointer transition-colors"
                    [class]="selectedTags().has(tag.tag) ? 'border-primary bg-primary/5' : 'border-border hover:bg-muted/40'">
                    <input
                      type="checkbox"
                      [checked]="selectedTags().has(tag.tag)"
                      (change)="toggleTag(tag.tag)"
                      class="rounded border-input accent-primary"
                    />
                    <div class="flex items-center gap-2.5">
                      <div class="w-8 h-8 rounded-md border bg-muted/50 flex items-center justify-center shrink-0">
                        <ng-icon name="lucideBox" class="w-4 h-4 text-muted-foreground" />
                      </div>
                      <span class="text-sm font-normal">{{ tag.label }}</span>
                    </div>
                  </label>
                }
              </div>
            }
          </div>
        } @else {
          <p class="text-xs text-muted-foreground px-1">Keine Mediendateien verfügbar.</p>
        }
      </div>
    }

    <!-- Error -->
    @if (phase() === 'error') {
      <div class="py-4 text-sm text-destructive">
        Laden der verfügbaren Dateien fehlgeschlagen. Bitte versuche es erneut.
      </div>
    }

    <hlm-dialog-footer>
      @if (phase() === 'choosing') {
        <button hlmBtn variant="outline" type="button" brnDialogClose>Abbrechen</button>
        <button
          hlmBtn
          type="button"
          [disabled]="!hasAnySelection()"
          (click)="confirm()"
        >
          <ng-icon name="lucideDownload" class="w-4 h-4 mr-2" />
          Als ZIP herunterladen
        </button>
      } @else if (phase() === 'error') {
        <button hlmBtn type="button" brnDialogClose>Schließen</button>
      }
    </hlm-dialog-footer>
  </hlm-dialog-content>
</hlm-dialog>
